import React, { useState, useRef } from "react";
import axiosInstance from "../../config/axiosConfig"; // Asegúrate de tener tu configuración de axios

const BuscarPaciente = ({ onSelect, onClear = () => {}, valoresTurnos = false, conAuxiliares = false, conAcuerdos = false, conVisita = false, conAcuerdosAuxiliar = false, conEnfermeria = false, conTurno = false}) => {
    const [pacientes, setPacientes] = useState([]); // Lista de pacientes para el buscador
    const [textoBusqueda, setTextoBusqueda] = useState(""); // Texto del buscador
    const [loading, setLoading] = useState(false); // Estado para el indicador de carga
    const abortControllerRef = useRef(null);

    const buscarPacientes = async () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();

        setLoading(true); // Activar el indicador de carga

        try {
            const response = await axiosInstance.get(`/paciente/busqueda/texto`, {
                params: {
                    search: textoBusqueda,
                    valoresTurnos, // Pasar el booleano como parámetro
                    conAuxiliares,
                    conAcuerdos,
                    conVisita,
                    conAcuerdosAuxiliar,
                    conEnfermeria,
                    conTurno
                },
                signal: abortControllerRef.current.signal,
            });
            if (response.data.error) {
                return;
            }
            setLoading(false);
            setPacientes(response.data.data);
        } catch (error) {
            if (error.name !== "AbortError") {
                setLoading(false);
            }
        }
    };

    const handleSelectPaciente = (paciente) => {
        onSelect(paciente); // Llamamos a onSelect para pasar el paciente seleccionado
        setTextoBusqueda(`${paciente.nombres} ${paciente.apellidoPaterno} ${paciente.apellidoMaterno} (${paciente.rut})`); // Actualizamos el input con el nombre del paciente
        setPacientes([]); // Limpiamos la lista de pacientes
    };

    const handleClearSearch = () => {
        setTextoBusqueda(""); // Limpiamos el campo de búsqueda
        setPacientes([]); // Limpiamos la lista de pacientes
        onClear([]);
        // onSelect('');// Revisar Bug
    };

    return (
        <div className="buscador-container mb-3">
            <label className="form-label">Buscar Paciente</label>
            <div className="input-group">
                <input
                    type="text"
                    className="form-control buscador-input"
                    value={textoBusqueda}
                    onChange={(e) => setTextoBusqueda(e.target.value)}
                    onKeyUp={buscarPacientes}
                    placeholder="Buscar por nombre o RUT"
                />
                {textoBusqueda && ( // Mostrar el botón solo si hay texto en el input
                    <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleClearSearch}
                    >
                        &times; {/* Icono de "x" */}
                    </button>
                )}
                {loading && (
                    <span className="input-group-text">
                        {/* Spinner de Bootstrap */}
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only"></span>
                        </div>
                    </span>
                )}
            </div>
            {pacientes.length > 0 && (
                <ul className="list-group search-results">
                    {pacientes.map((paciente) => (
                        <li
                            key={paciente.id}
                            className="list-group-item list-group-item-action"
                            onClick={() => handleSelectPaciente(paciente)} // Llamamos a onSelect cuando se hace clic en un paciente
                        >
                            {paciente.nombres} {paciente.apellidoPaterno} {paciente.apellidoMaterno} ({paciente.rut})
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default BuscarPaciente;